<form id="payment-form" (submit)="handleSubmit($event)"
    class="p-6 max-w-md mx-auto bg-white rounded-[16px] shadow-md space-y-4 flex flex-col w-full justify-center items-center">
    <div id="payment-element" class="p-4 border rounded-lg w-full"></div>

    <div class="w-[300px] h-[50px]">
        <app-custom-button id="submit" buttonText="{{'shared.continue' | transloco }}" [isDisabled]="false"
            backgroundColor="bg-primary" textColor="text-white" borderColor="border:bg-primary"
            hoverBackgroundColor="hover:bg-primary-1200">
        </app-custom-button>
    </div>

    <div id="error-message" class="text-error text-sm mt-2"></div>
</form>